import { solarSalesAxios } from '@infrastructure/apiService'

export type UnbindErrorReason =
  | 'contract-not-found'
  | 'unable-to-unbind-electricity'
  | 'unable-to-unbind-product-project'
  | 'unknown'

type Callbacks = {
  respondWithSuccess: () => void
  respondWithError: (reason: UnbindErrorReason) => void
}

const KNOWN_REASONS: UnbindErrorReason[] = [
  'contract-not-found',
  'unable-to-unbind-electricity',
  'unable-to-unbind-product-project',
]

function extractReason(error: unknown): UnbindErrorReason {
  const reason = (error as { response?: { data?: { reason?: string } } })
    ?.response?.data?.reason
  return KNOWN_REASONS.includes(reason as UnbindErrorReason)
    ? (reason as UnbindErrorReason)
    : 'unknown'
}

export function handleUnbindContract() {
  return { execute }

  async function execute(
    cups: string,
    { respondWithSuccess, respondWithError }: Callbacks
  ) {
    try {
      await solarSalesAxios.get(`${cups}/contract/unbind`)
      respondWithSuccess()
    } catch (error) {
      respondWithError(extractReason(error))
    }
  }
}
